// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__12wF0","calendarButtons":"ClockData_calendarButtons__1iCpc"};